"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RateDto = void 0;
class RateDto {
}
exports.RateDto = RateDto;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoicmF0ZUR0by5qcyIsInNvdXJjZVJvb3QiOiIuL3NyYy8iLCJzb3VyY2VzIjpbInBhY2thZ2VzL21vZGVscy9kdG8vcmF0ZUR0by50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7QUFBQSxNQUFhLE9BQU87Q0FJbkI7QUFKRCwwQkFJQyIsInNvdXJjZXNDb250ZW50IjpbImV4cG9ydCBjbGFzcyBSYXRlRHRve1xuICAgIENpdHk6IHN0cmluZztcbiAgICBDb3VudHk6IHN0cmluZztcbiAgICBSYXRlOiBzdHJpbmc7XG59Il19